const themeStorage = {
  get() {
    try {
      return localStorage.getItem('theme-mode');
    } catch (e) {
      return null;
    }
  },
  set(value) {
    try {
      localStorage.setItem('theme-mode', value);
    } catch (e) {
      // Storage can be blocked in some browser contexts (e.g., strict privacy or iframes).
    }
  },
  remove() {
    try {
      localStorage.removeItem('theme-mode');
    } catch (e) {
      // Ignore storage errors.
    }
  },
};

class ThemeToggle extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.iconSun = this.querySelector('.icon-sun');
    this.iconMoon = this.querySelector('.icon-moon');
    this.text = this.querySelector('.text-label');

    // Bind events
    if (this.button) {
      this.button.addEventListener('click', this.toggleMode.bind(this));
    }

    // Initialize
    this.init();
  }

  init() {
    // Normalize legacy storage value: light should no longer be persisted.
    if (themeStorage.get() === 'light') {
      themeStorage.remove();
    }

    // Determine current mode based on class presence (set by blocking script).
    if (document.documentElement.classList.contains('dark')) {
      this.setMode('dark');
    } else {
      this.setMode('light');
    }
  }

  toggleMode(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    // Toggle state
    // Temporarily disable menu drawer focusout check
    const drawer = this.closest('.menu-drawer-container') || document.getElementById('Details-menu-drawer-container');
    if (drawer) drawer.setAttribute('data-ignore-focus', 'true');

    if (document.documentElement.classList.contains('dark')) {
      this.setMode('light');
      themeStorage.remove();
    } else {
      this.setMode('dark');
      themeStorage.set('dark');
    }
    // Prevent menu drawer from closing by restoring focus immediately
    // The menu-drawer component checks document.activeElement in a setTimeout on focusout
    this.button.focus();

    // Clean up flag after timeout
    setTimeout(() => {
       if (drawer) drawer.removeAttribute('data-ignore-focus');
    }, 200);
  }

  setMode(mode) {
    if (mode === 'dark') {
      document.documentElement.classList.add('dark');
      this.iconSun?.classList.remove('hidden');
      this.iconMoon?.classList.add('hidden');
      if (this.text) this.text.textContent = window.themeVariables.strings.lightMode;
    } else {
      document.documentElement.classList.remove('dark');
      // Do NOT add 'light' class because it conflicts with base.css .light { opacity: 0.7 }
      this.iconSun?.classList.add('hidden');
      this.iconMoon?.classList.remove('hidden');
      if (this.text) this.text.textContent = window.themeVariables.strings.darkMode; 
    }
    
    // Dispatch custom event to notify other components
    document.dispatchEvent(new CustomEvent('theme:change', { detail: { mode } }));
  }
}

// Global listener to sync all instances
document.addEventListener('theme:change', (e) => {
    const mode = e.detail.mode;
    document.querySelectorAll('theme-toggle').forEach(el => {
        // Find internal elements for EACH instance
        const iconSun = el.querySelector('.icon-sun');
        const iconMoon = el.querySelector('.icon-moon');
        const text = el.querySelector('.text-label');

        if (mode === 'dark') {
             iconSun?.classList.remove('hidden');
             iconMoon?.classList.add('hidden');
             if (text) text.textContent = window.themeVariables.strings.lightMode;
        } else {
             iconSun?.classList.add('hidden');
             iconMoon?.classList.remove('hidden');
             if (text) text.textContent = window.themeVariables.strings.darkMode;
        }
    });
});


customElements.define('theme-toggle', ThemeToggle);


